import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import AuthBoot from './components/AuthBoot';
import { MeProvider } from './lib/useMe';
import '@navipoint/ui/styles.css';
import './styles.css';
import './v5/v5.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthBoot>
        <MeProvider>
          <App />
        </MeProvider>
      </AuthBoot>
    </BrowserRouter>
  </StrictMode>,
);
